export const formatTimes = (dateSelect) => {
  let hours = dateSelect.getHours();
  let minutes = dateSelect.getMinutes();
  return `${hours.toString().padStart(2, '0')}h${minutes.toString().padStart(2, '0')}min`;
};
